import { Directive, ElementRef, Renderer2,AfterViewInit } from '@angular/core';
import { GetArticlesService } from 'src/app/services/get-articles.service';

@Directive({
  selector: '[appRenderHtml]'
})
export class RenderHtmlDirective implements AfterViewInit {

  constructor(private el: ElementRef, private renderer: Renderer2, private articleService:GetArticlesService) { }

  ngAfterViewInit() {
    this.renderContent();
  }

  private renderContent() {
    // Check if content has already been rendered
    if (this.el.nativeElement.querySelector('ng-container')) {
      return;
    }

    // Create ng-container to hold the badges
    const ngContainer = this.renderer.createElement('ng-container');
//     const dimensionsSpan = this.renderer.createElement('span');
// this.renderer.addClass(dimensionsSpan, '__dimensions_badge_embed__');
//  this.renderer.setStyle(dimensionsSpan, 'padding', '20px 2px');
// this.renderer.setAttribute(dimensionsSpan, 'data-doi', '10.1001/jama.2016.9797');
// // this.renderer.setAttribute(dimensionsSpan, 'data-pmid', '21771119');
// this.renderer.setAttribute(dimensionsSpan, 'data-legend', 'hover-bottom');
// //this.renderer.setAttribute(dimensionsSpan, 'data-style', 'medium_circle');
// this.renderer.appendChild(ngContainer, dimensionsSpan);

// Create and append the Dimensions badge script element
// const dimensionsScript = this.renderer.createElement('script');
// this.renderer.setAttribute(dimensionsScript, 'async', '');
// this.renderer.setAttribute(dimensionsScript, 'type', 'application/javascript');
// this.renderer.setAttribute(dimensionsScript, 'src', 'https://badge.dimensions.ai/badge.js');
// this.renderer.setAttribute(dimensionsScript, 'charset', 'utf-8');
// this.renderer.appendChild(ngContainer, dimensionsScript);

// Create and append the Scite badge span element
const sciteSpan = this.renderer.createElement('span');
this.renderer.addClass(sciteSpan, 'scite-badge');
this.renderer.setStyle(sciteSpan, 'padding', '0px 10px');
this.renderer.setAttribute(sciteSpan, 'data-doi', '10.1016/j.biopsych.2005.08.012');
this.renderer.setAttribute(sciteSpan, 'data-tally-show', 'false');
this.renderer.setAttribute(sciteSpan, 'data-section-tally-show', 'true');
this.renderer.setAttribute(sciteSpan, 'data-show-labels', 'true');
this.renderer.setAttribute(sciteSpan, 'data-tooltip-placement', 'left');
this.renderer.setAttribute(sciteSpan, 'data-small', 'true');
this.renderer.setAttribute(sciteSpan, 'data-show-zero', 'true');
this.renderer.setAttribute(sciteSpan, 'data-section-tally-layout', 'vertical');
this.renderer.setAttribute(sciteSpan, 'data-chart-type', 'donut');
sciteSpan.addEventListener('mouseover', () => {
  // this.articleService.scite_badge_hover = true;
  this.articleService.sciteBadgeOver(true);
});
sciteSpan.addEventListener('mouseleave', () => {
  // this.articleService.scite_badge_hover = false;
  this.articleService.sciteBadgeOver(false);
});
this.renderer.appendChild(ngContainer, sciteSpan);

// Create and append the Scite badge script element
const sciteScript = this.renderer.createElement('script'); 
this.renderer.setAttribute(sciteScript, 'async', '');
this.renderer.setAttribute(sciteScript, 'type', 'application/javascript');
// this.renderer.setAttribute(sciteScript, 'src', 'https://cdn.scite.ai/badge/scite-badge-latest.min.js');
this.renderer.appendChild(ngContainer, sciteScript);

// Append the ng-container to the host element
this.renderer.appendChild(this.el.nativeElement, ngContainer);

   
  }
}
